<div class="tooltip-wrapper" [ngStyle]="{'top.px': config.top, 'left.px': config.left}">
  <div class="link-block">
    <div class="heading">{{ "SHARE_TOOLTIP.title_sharetooltip" | translate }}</div>
    <div class="copy-link" (click)="copyLink()">{{ "SHARE_TOOLTIP.copy_sharetooltip" | translate }}</div>
    <div class="link">{{url}}</div>
  </div>

  <div class="social-block">
    <div class="heading">{{ "SHARE_TOOLTIP.social_sharetooltip" | translate }}</div>
    <div class="social">
      <img loading="lazy" src="/assets/icons/social-linkedin-blue.svg" alt="linkedin" (click)="shareLIN()">
    </div>
  </div>
  <br>
  <img loading="lazy" *ngIf="brandsPage()" [src]="urlImage()" class="share-image" alt="image-share">
</div>
